<template lang="pug" src="./header.pug" />

<script>
import Header from './header'

export default {
    name: 'lairdnd-header',

    mixins: [
        Header
    ],
}
</script>

<style lang="scss">

@import '../../../sass/app/controls/location-search.scss';
@import '../../../sass/app/layouts/header.scss';

</style>
